var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "container" }, [
    _c("br"),
    _c("br"),
    _vm._v(" "),
    _setup.isAccessable
      ? _c("div", { staticClass: "jumbotron" }, [
          _c("h1", { staticClass: "display-4" }, [
            _setup.isEmailAuthorized
              ? _c("span", [_vm._v("Congratulations!")])
              : _c("span", [_vm._v("Welcome!")]),
          ]),
          _vm._v(" "),
          _setup.isEmailAuthorized
            ? _c("p", { staticClass: "lead" }, [
                _vm._v("We confirmed your access to "),
                _c("strong", [_vm._v(_vm._s(_setup.resourceName))]),
                _vm._v(" owned by "),
                _c("strong", [_vm._v(_vm._s(_setup.organizationName))]),
                _vm._v(" data in TransparentChoice application"),
              ])
            : _c("p", { staticClass: "lead" }, [
                _vm._v("You are about to access "),
                _c("strong", [_vm._v(_vm._s(_setup.resourceName))]),
                _vm._v(" owned by "),
                _c("strong", [_vm._v(_vm._s(_setup.organizationName))]),
                _vm._v(" data in TransparentChoice application"),
              ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _setup.isEmailAuthorized
            ? _c("div", [
                !_setup.isAuthenticatedUser
                  ? _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-6" }, [
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-lg btn-success",
                            attrs: { href: _setup.accessUrl },
                          },
                          [_vm._v("Go to " + _vm._s(_setup.resourceName))]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6" }),
                    ])
                  : _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-lg btn-success",
                            staticStyle: { margin: "20px" },
                            attrs: { href: _setup.accessUrl },
                          },
                          [_vm._v("Go to " + _vm._s(_setup.resourceName))]
                        ),
                      ]),
                    ]),
              ])
            : _c("div", [
                !_setup.succeedSendEmailConfirmationCommandV1
                  ? _c(
                      "div",
                      [
                        _c("p", [
                          _vm._v(
                            "We have to confirm your email for security reasons before you will be able to access it"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group mb-3" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _setup.email,
                                expression: "email",
                              },
                            ],
                            staticClass: "form-control form-control-lg",
                            attrs: { type: "email", placeholder: "Your email" },
                            domProps: { value: _setup.email },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _setup.email = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group-append" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { type: "button" },
                                on: {
                                  click:
                                    _setup.invokeSendEmailConfirmationCommandV1,
                                },
                              },
                              [_vm._v("Confirm")]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("ValidationError", {
                          attrs: {
                            context: "Email",
                            errors: _setup.validationErrors,
                          },
                        }),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("div", { staticStyle: { "text-align": "center" } }, [
                          _c("h5", [_vm._v("or")]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-secondary",
                              attrs: {
                                href: `/#/signin?returnUrl=${encodeURIComponent(
                                  _setup.accessUrl
                                )}`,
                              },
                            },
                            [
                              _vm._v(
                                "\n                        Sign in with TransparentChoice account\n                    "
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    )
                  : _c("div", [
                      _c("p", [
                        _vm._v(
                          "We send confirmation email on your maiblox. Please follow the link from that email to continue..."
                        ),
                      ]),
                    ]),
              ]),
        ])
      : _c("div", { staticClass: "jumbotron" }, [
          _c("h1", { staticClass: "display-4" }, [_vm._v("Access denied")]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_setup.accessIssueDetails))]),
          _vm._v(" "),
          _c("hr"),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }